import { useAccessRequest } from "@/context/access-request-context";
import { WorkflowButton } from "../Buttons";

export default function TaskActions() {
	const {
		tasks,
		performAction,
		loadingAction,
		revokeAccessRequest,
		isRevokingRequest,
		requestDetails,
	} = useAccessRequest();
	const variables = tasks?.[0]?.variables;

	return (
		<>
			{variables?.actions?.length > 0 &&
				variables?.actions?.map((action) => (
					<WorkflowButton
						disabled={loadingAction === action}
						className={`cursor-pointer px-4 py-2 ${
							action === "approve"
								? "bg-primaryGreen hover:bg-primaryGreen-500"
								: action === "reject" ||
										action === "delete" ||
										action === "cancel"
									? "text-white border border-red-700 bg-red-700 hover:bg-red-500 hover:text-white"
									: "bg-blue-500 hover:bg-blue-600"
						} rounded-md text-sm  transition-colors`}
						onClick={() => performAction(action, tasks?.[0]?.id)}
						key={action}
						type="button"
						title={variables[`${action}.description`]}
						loading={loadingAction === action}
					/>
				))}
			{requestDetails?.status === "APPROVED" && (
				<WorkflowButton
					loading={isRevokingRequest}
					title="Revoke"
					type="button"
					className="text-textColor border border-yellow-500 bg-transparent hover:bg-yellow-500 cursor-pointer px-4 py-2 rounded-md text-sm  transition-colors"
					onClick={() =>
						revokeAccessRequest(requestDetails.id as unknown as number)
					}
				/>
			)}
		</>
	);
}
